import { createSelector } from "reselect";
import { IExportFormState } from "../../forms/ExportForm/type";
import { State } from "../type";

export function selectFormState(state: State): IExportFormState {
    return state.form;
}

export const selectExportForm = createSelector(selectFormState, state => state.exportForm);
